import { gql } from '@apollo/client';
import getUserNames from '../../user/getUserNames';

const COMMENT_REACTION_FIELDS_FRAGMENT = gql`
  fragment CommentReactionFields on PublicCommentReactionFields {
    id
    emoji
    author {
      id
      name
      ...getUserNames_user
    }
  }
  ${
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
    getUserNames.fragments.user
  }
`;

export default COMMENT_REACTION_FIELDS_FRAGMENT;
